import { useId } from 'react';

type Props = {
  size?: number;
  fill?: string;
};

const Star = ({ size = 24, fill = '#FADB14' }: Props) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_i_301_5811)">
        <path
          d="M21.2838 8.27547L15.333 7.41063L12.6728 2.01766C12.6002 1.87 12.4806 1.75047 12.333 1.67782C11.9627 1.495 11.5127 1.64735 11.3275 2.01766L8.66735 7.41063L2.71657 8.27547C2.55251 8.29891 2.40251 8.37625 2.28767 8.49344C2.14883 8.63614 2.07232 8.82813 2.07496 9.02721C2.07759 9.22629 2.15916 9.41618 2.30173 9.55516L6.6072 13.7528L5.59001 19.6802C5.56616 19.818 5.58141 19.9598 5.63405 20.0895C5.68669 20.2192 5.77461 20.3315 5.88783 20.4137C6.00105 20.4959 6.13504 20.5448 6.27462 20.5547C6.4142 20.5647 6.55377 20.5353 6.67751 20.47L12.0002 17.6716L17.3228 20.47C17.4681 20.5473 17.6369 20.5731 17.7986 20.545C18.2064 20.4747 18.4806 20.088 18.4103 19.6802L17.3931 13.7528L21.6986 9.55516C21.8158 9.44032 21.8931 9.29032 21.9166 9.12625C21.9799 8.7161 21.6939 8.33641 21.2838 8.27547Z"
          fill={fill}
        />
      </g>
      <defs>
        <filter
          id={useId()}
          x="2.07489"
          y="0.600464"
          width="19.8505"
          height="19.9562"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-2" />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.306692 0 0 0 0 0.276023 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_301_5811" />
        </filter>
      </defs>
    </svg>
  );
};

export default Star;
